import React, { useState, useEffect } from "react";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import search from "../../assets/images/search-lg.svg";
import {
  deleteReferalUser,
  getAllReferalUsers,
} from "../../../redux/referals/actions";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import CardHeader from "../../Common/CardHeader/CardHeader";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import UserDelete from "../User/UserDelete";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import Spinner from "../../Layouts/Spinner";
import { showToast } from "../../Common/Utils/Toaster";

const ReferalList = () => {
  const navigate = useNavigate();
  const [theUserData, setUsersData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [modals, setModals] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);

  const handleGetReferalUsers = () => {
    getAllReferalUsers(params, setIsLoading)
      .then((res) => {
        if (res.data.status) {
          setUsersData(res.data.response);
        }
      })
      .catch((e) => console.log(e.message, "referal user errors"));
  };

  const updateComponent = (id) => {
    navigate(`/referallist/updateuser/${id}`);
  };

  const addComponent = () => {
    navigate("/user/add");
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      deleteReferalUser(currentComponent.id)
        .then((res) => {
          if (res.data.status) {
            handleGetReferalUsers();
          }
        })
        .catch((e) => console.log(e, "error"));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const handleExportReport = () => {
    setExportLoader(true);
    getAllReferalUsers({ search_key: params.search_key }, setIsLoading)
      .then((response) => {
        if (response.data) {
          setExportLoader(false);
          const header = [
            [
              "Sl",
              "Customer Name",
              "Mobile Number",
              "Email ID",
              "Total Referral Amount",
              "Total Referrals",
            ],
          ];
          const data = response.data.response.users.map((prop, index) => [
            index + 1,
            prop.full_name,
            prop.country_code + prop.mobile_number,
            prop.email_id ?prop.email_id: "NA",
            prop.re_amount,
            prop.referral_count,
          ]);

          const worksheet = XLSX.utils.aoa_to_sheet(header); 
          XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "ReferralList.xlsx");
        }
      })
      .catch((e) => {
        console.log(e, "while exporting reports");
        // swal({
        //   text: e.message,
        //   icon: "error",
        //   button: "Close",
        //   timer: 1500,
        // });
        setExportLoader(false);
        showToast(e.message, "error")
      });
  };

  useEffect(() => {
    handleGetReferalUsers();
  }, [params]);

  console.log(params, "the params")
  return (
    <Card className="py-3">
      {isLoading ? (
        <FullScreenLoader />
      ) : theUserData && theUserData?.users.length != 0 ? (
        <>
          <div className="search-export">
            <CardHeader
              headerTitle="Referral List"
              params={params}
              setParams={setParams}
              addmodel={addComponent}
              search={search}
              setOpenFilter={setOpenFilter}
              modals={modals}
              hidefilter={true}
              setModals={setModals}
            />
            <button
              disabled={exportLoader}
              type="button"
              className="submit-btn"
              onClick={() => handleExportReport()}
              style={{ width: "max-content" }}
            >
              {exportLoader ? <Spinner /> : "Export"}
            </button>
          </div>

          <CardBody>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Sl No</th>
                  <th scope="col">Full Name</th>
                  <th scope="col">Contact</th>
                  <th scope="col">Total Referral Amount</th>
                  <th scope="col">Total Referrals</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {theUserData.users.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item?.full_name} </td>
                    <td>
                      <p>
                        {item?.country_code} {item?.mobile_number}
                      </p>
                      <p>{item?.email_id}</p>
                    </td>
                    <td>{item?.re_amount}</td>
                    <td>{item?.referral_count}</td>
                    <td>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          className="border-button"
                          onClick={() => updateComponent(item?.id)}
                        >
                          <span>Update</span>
                        </button>
                        <button
                          className="background-button"
                          onClick={() => {
                            setModal(true);
                            setCurrentComponent(item);
                          }}
                        >
                          <span>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CommonPagination
              params={params}
              setParams={setParams}
              pagination_meta={theUserData.pagination_meta}
            />
          </CardBody>
        </>
      ) : (
        <CardBody>
          <tr>
            <td colSpan="7" className="text-center">
              No Users Found
            </td>
          </tr>
        </CardBody>
      )}
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <UserDelete
          modalTitle={"Referal Customer"}
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </Card>
  );
};

export default ReferalList;
